// © Microsoft Corporation. All rights reserved.

/** Windows Widget client id used for auth token generation (MSA) */
export const winWidClientIdMsa = "00000000400F9D16";

/** Windows Widget client id used for auth token generation (AAD) */
export const winWidClientIdAad = "3a4d129e-7f50-4e0d-a7fd-033add0a29f4";

/** Scope for msa/rps token request */
export const winWidScopeMsa = "service::www.msn.com::MBI_SSL";

/** Scope for aad token request */
export const winWidScopeAad = "User.Read Userinfo.ReadWrite";

/** MSA/RPS auth token is issued against this resource */
export const winWidResourceMsa ="https://www.api.msn.com/";

/** AAD auth token is issued against this resource */
export const winWidResourceAad = "https://enterprisenews.microsoft.com/";